import { WhatsAppIcon, buildWhatsAppLink } from "./Header";
import { resolveImageUrl } from "../../lib/api";

const BANNER_IMAGE =
  "https://images.unsplash.com/photo-1639776738932-956082f0b704?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxzbWFydHBob25lJTIwcmVwYWlyJTIwdGVjaG5pY2lhbnxlbnwwfHx8fDE3OTE5NzY3NDh8MA&ixlib=rb-4.1.0&q=85";

export default function Atmosphere({ whatsappNumber, content }) {
  const a = content?.atmosphere || {};
  const eyebrow = a.eyebrow || "Como Comprar";
  const title = a.title || "Escolha pelo site ou chame a gente no WhatsApp.";
  const text = a.text || "Atualizamos o catálogo com frequência. Você pode montar sua sacola aqui no site ou mandar mensagem direto para nosso atendimento — inclusive para orçamento de reparo do seu aparelho.";
  const image = a.image_url ? resolveImageUrl(a.image_url) : BANNER_IMAGE;

  return (
    <section className="py-20 bg-[#1A1816] text-[var(--site-bg)] relative overflow-hidden">
      <img
        src={image}
        alt="Técnico reparando um celular"
        className="absolute inset-0 w-full h-full object-cover opacity-20"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_80%_20%,#3A2F25_0%,#1A1816_70%)] opacity-80"></div>
      <div className="relative max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        <div>
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--brand)] block mb-3">{eyebrow}</span>
          <h2 className="text-3xl md:text-5xl font-display font-bold leading-tight mb-6">{title}</h2>
          <p className="text-[#D5CDC2] text-base leading-relaxed mb-8">{text}</p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#catalogo"
              data-testid="atmosphere-shop-button"
              className="bg-[var(--brand)] text-white px-6 py-3.5 rounded-full font-display text-xs uppercase tracking-wider font-semibold text-center hover:bg-[var(--brand-dark)] transition-colors"
            >
              Comprar Online
            </a>
            <a
              href={buildWhatsAppLink(whatsappNumber, "Olá! Quero um orçamento com a assistência técnica.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="atmosphere-whatsapp-button"
              className="inline-flex items-center justify-center gap-2 border border-[#443E38] text-white px-6 py-3.5 rounded-full font-display text-xs uppercase tracking-wider font-semibold hover:border-white transition-colors"
            >
              <WhatsAppIcon />
              Falar com Atendente
            </a>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="p-6 rounded-2xl bg-[#252220]/90 border border-[#332E2A]">
            <span className="font-display text-3xl font-bold text-[var(--brand)] block mb-2">Rápido</span>
            <p className="text-xs text-[#A89E94]">Entrega rápida na sua cidade e região.</p>
          </div>
          <div className="p-6 rounded-2xl bg-[#252220]/90 border border-[#332E2A]">
            <span className="font-display text-3xl font-bold text-[var(--brand)] block mb-2">Próximo</span>
            <p className="text-xs text-[#A89E94]">Atendimento personalizado do pedido à entrega.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
